export const messages = {
  en: {
    listApplyRoomDiscountRecord: {
      title: 'Decoration Tracking Record',
      id: 'ID',
      room: 'Room',
      operator: 'Operator',
      createTime: 'Create Time',
      status: 'Status',
      isViolation: 'Is Violation',
      remark: 'Remark',
      fetchError: 'Failed to fetch records'
    },
    applyRoomDiscountRecord: {
      title: 'Inspection Tracking',
      room: 'Room',
      status: 'Status',
      isViolation: 'Is Violation',
      selectViolation: 'Please select violation status',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remarks',
      uploadImages: 'Upload Images',
      uploadVideo: 'Upload Video',
      violationRequired: 'Violation status is required',
      remarkRequired: 'Remark is required'
    },
    deleteApplyRoomDiscountRecord: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this inspection record?'
    },
    uploadImage: {
      maxCountError: 'Maximum {count} images can be uploaded',
      sizeError: 'Image size cannot exceed 2MB',
      uploadFailed: 'Image upload failed'
    },
    uploadVedio: {
      uploadButton: 'Upload Video',
      sizeError: 'Video size cannot exceed 500MB',
      uploadSuccess: 'Video uploaded successfully',
      uploadFailed: 'Video upload failed'
    }
  },
  zh: {
    listApplyRoomDiscountRecord: {
      title: '装修跟踪记录',
      id: 'ID',
      room: '房屋',
      operator: '操作人员',
      createTime: '创建时间',
      status: '状态',
      isViolation: '是否违规',
      remark: '备注',
      fetchError: '获取记录失败'
    },
    applyRoomDiscountRecord: {
      title: '验房跟踪',
      room: '房屋',
      status: '状态',
      isViolation: '是否违规',
      selectViolation: '请选择是否违规',
      remark: '备注',
      remarkPlaceholder: '请填写备注',
      uploadImages: '上传图片',
      uploadVideo: '上传视频',
      violationRequired: '是否违规不能为空',
      remarkRequired: '备注不能为空'
    },
    deleteApplyRoomDiscountRecord: {
      title: '请确认您的操作',
      confirmText: '确定删除验房记录吗？'
    },
    uploadImage: {
      maxCountError: '最多只能上传{count}张图片',
      sizeError: '图片大小不能超过2MB',
      uploadFailed: '图片上传失败'
    },
    uploadVedio: {
      uploadButton: '上传视频',
      sizeError: '视频大小不能超过500MB',
      uploadSuccess: '视频上传成功',
      uploadFailed: '视频上传失败'
}
  },
  'zh-TW': {
    listApplyRoomDiscountRecord: {
      title: '裝修跟蹤記錄',
      id: 'ID',
      room: '房屋',
      operator: '操作人員',
      createTime: '創建時間',
      status: '狀態',
      isViolation: '是否違規',
      remark: '備註',
      fetchError: '獲取記錄失敗'
    },
    applyRoomDiscountRecord: {
      title: '驗房跟蹤',
      room: '房屋',
      status: '狀態',
      isViolation: '是否違規',
      selectViolation: '請選擇是否違規',
      remark: '備註',
      remarkPlaceholder: '請填寫備註',
      uploadImages: '上傳圖片',
      uploadVideo: '上傳影片',
      violationRequired: '是否違規不能為空',
      remarkRequired: '備註不能為空'
    },
    deleteApplyRoomDiscountRecord: {
      title: '請確認您的操作',
      confirmText: '確定刪除驗房記錄嗎？'
    },
    uploadImage: {
      maxCountError: '最多只能上傳{count}張圖片',
      sizeError: '圖片大小不能超過2MB',
      uploadFailed: '圖片上傳失敗'
    },
    uploadVedio: {
      uploadButton: '上傳影片',
      sizeError: '影片大小不能超過500MB',
      uploadSuccess: '影片上傳成功',
      uploadFailed: '影片上傳失敗'
    }
  }
}